import { useTranslation } from "react-i18next"

export function LoadingComponet() {
  const { t } = useTranslation()

  return (
    <div className="max-w-xl mx-auto py-10 text-center space-y-6">
      <div className="w-12 h-12 border-4 border-orange-600 border-t-transparent rounded-full animate-spin mx-auto"></div>

      <p className="text-gray-600 font-bold tracking-tight">{t("publicMenu:common.loading_orders")}</p>
    </div>
  )
}
